import Theme from "../../styles/Theme/Theme";

export const getColorByPriority = (priority) => {
    switch (priority) {
        case '1 -  High':
            return Theme.color["black-1"];
        case '2 - Medium High':
            return Theme.color.red;
        case '3 - Medium':
            return Theme.color.orange;
        case '4 - Medium Low':
            return Theme.color.yellow;
        // case '5 - Low':
        //     return Theme.color['green-1'];
        default:
            return Theme.color["coolgray-10"];
    };
};

export const getColorBySeverity = (severity) => {
    switch (severity) {
        case '5 - Very High':
            return Theme.color["black-1"];
        case '4 - High':
            return Theme.color.red;
        case '3 - Medium':
            return Theme.color.orange;
        case '2 - Low':
            return Theme.color.yellow;
        // case '5 - Low':
        //     return Theme.color['green-1'];
        default:
            return Theme.color["coolgray-10"];
    };
};